import { actions as snactions } from 'store/snackbar'

import service from '../parent-api-service'
import types from '../types'

const fetchParents = () => (dispatch) => {
  dispatch({
    type: types.FETCH_PARENTS_START,
  })
  return service
    .getParents()
    .then((payload) => {
      dispatch({
        type: types.FETCH_PARENTS_SUCCESS,
        payload,
      })
    })
    .catch(() => {
      dispatch({ type: types.FETCH_PARENTS_FAILURE })
      dispatch(snactions.addSnackbarItem('An error occured when looking up parents'))
    })
}

export default fetchParents
